import { useState, type MouseEvent } from 'react';

import GlobalCookieBanner from '@web-platform/global-components-cookie-banner';
import ConsentBanner from '@web-platform/global-components-unstable__consent-banner';
import { useFeatureFlags } from '@web-platform/shared-travel-tools-data-access-frontend';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import type { CookieBannerSerializableProps } from '@web-platform/shared-travel-tools-types/src/global-components';

type Props = CookieBannerSerializableProps & { isProductionEnv: boolean };

export const CookieBanner = (props: Props) => {
  const { enableKetchCMP } = useFeatureFlags();
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  const logger = { logError, logOperationalEvent, logWarn };
  const onPolicyAcceptClick = (_event: MouseEvent<HTMLButtonElement> | null) => setIsOpen(false);

  return enableKetchCMP ? (
    <ConsentBanner
      isProductionEnv={props.isProductionEnv}
      onPolicyAcceptClick={onPolicyAcceptClick}
      strings={props.strings}
      logger={logger}
    />
  ) : (
    <GlobalCookieBanner {...props} logger={logger} onPolicyAcceptClick={onPolicyAcceptClick} />
  );
};
